var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxOncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_box",
    d: "M7.425 13.6127L14.6208 6.41694L13.8246 5.62072L7.425 12.0203L4.21875 8.81404L3.42253 9.61025L7.425 13.6127ZM1.81744 18.6665C1.29956 18.6665 0.867188 18.4931 0.520312 18.1462C0.173438 17.7993 0 17.3669 0 16.8491V2.48394C0 1.96607 0.173438 1.53369 0.520312 1.18682C0.867188 0.839941 1.29956 0.666504 1.81744 0.666504H16.1826C16.7004 0.666504 17.1328 0.839941 17.4797 1.18682C17.8266 1.53369 18 1.96607 18 2.48394V16.8491C18 17.3669 17.8266 17.7993 17.4797 18.1462C17.1328 18.4931 16.7004 18.6665 16.1826 18.6665H1.81744Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOncheck);
export default __webpack_public_path__ + "static/media/checkbox-oncheck.a7b7034b82cc074b9e77638d44e3e7b2.svg";
export { ForwardRef as ReactComponent };